import React from "react";

const MedsCheck = () => {
  return (
    <div className="bg-white max-w-[460px]">
      <div className="flex justify-between bg-slate-100 font-semibold text-md-body text-teal-300 gap-4 p-6 whitespace-nowrap">
        When MedsCheck Has Occurred At Another Pharmacy
      </div>
      <div className="flex flex-col items-stretch gap-3 p-6 text-left">
        <p className="w-full text-left text-teal-300 text-sm-body">
          Ask your patient if they have already had this service from another
          pharmacy and whether they completed the Patient Acknowledgement of
          Professional Pharmacy Services form elsewhere. Refer to Appendix B.
          <br />
          <br />
          If they have had a MedsCheck Annual from another pharmacy with the
          past year, they are not eligible under the program to receive another
          annual review. However, patients may be eligible for a MedsCheck
          Follow-up within the annual time frame under specific criteria.
          <br />
          <br />
          In Addition, the patient will have to complete another MedsCheck
          Patient Acknowledgement of Professional Pharmacy Services form at the
          second pharmacy.
          <br />
          <br />
          The Patient Consent / Acknowledgement form is part of the MedsCheck
          Follow-up module in REEL
          <br />
          <br />
          <span>
            <a
              href="https://www.ontario.ca/page/professional-pharmacy-services"
              target="_blank"
              className="underline"
            >
              Reference
            </a>
          </span>
        </p>
      </div>
    </div>
  );
};

export default MedsCheck;
